import { render, staticRenderFns } from "./staffSetParams.vue?vue&type=template&id=bba20e8a&scoped=true&"
import script from "./staffSetParams.vue?vue&type=script&lang=js&"
export * from "./staffSetParams.vue?vue&type=script&lang=js&"
import style0 from "./staffSetParams.vue?vue&type=style&index=0&id=bba20e8a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bba20e8a",
  null
  
)

export default component.exports